export interface SummaryPoint {
  timestamp: string;
  point: string;
}

export interface ContentIdeas {
  reels: string[];
  blogOutline: string;
  socialPosts: string[];
}

export interface AnalysisResult {
  isEducational: boolean;
  summary: SummaryPoint[];
  actionPlan: string[];
  contentIdeas: ContentIdeas;
}

export interface HistoryItem {
  id: string;
  date: number; // timestamp
  transcript: string;
  result: AnalysisResult;
  isFavorite: boolean;
}

export interface AppState {
  transcript: string;
  isLoading: boolean;
  result: AnalysisResult | null;
  currentId: string | null; // ID of the currently loaded history item
  error: string | null;
}

export interface UserProfile {
  id: string;
  full_name: string | null;
  avatar_url: string | null;
  email?: string;
}

export interface Plan {
  id: string;
  name: string;
  max_projects_per_month: number;
  max_favorites: number;
  history_retention_days: number;
  can_export_pdf: boolean;
  has_priority_support: boolean;
}

export interface Subscription {
  id: string;
  user_id: string;
  plan_id: string;
  status: string; // 'active', 'canceled', 'past_due', 'unpaid', 'trialing', etc.
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
  stripe_price_id?: string;
  current_period_start?: string;
  current_period_end?: string;
  cancel_at_period_end?: boolean;
  canceled_at?: string | null;
  plan?: Plan; // Joined relation
}

export interface MonthlyUsage {
  id: string;
  user_id: string;
  billing_cycle: string;
  projects_count: number;
}

export enum ViewMode {
  INPUT = 'INPUT',
  DASHBOARD = 'DASHBOARD',
  HISTORY = 'HISTORY',
  FAVORITES = 'FAVORITES'
}